import ContactForm from './ContactForm';

export default function EnquiryForm() {
    return (
      <div className="min-h-[80vh] bg-white text-black w-full px-4 lg:px-10 pt-10">
        <div className="w-full mx-auto py-12">
          <div className="flex flex-col lg:flex-row justify-center lg:justify-between lg:gap-16">
            {/* Left Section */}
            <div className="mb-8 lg:mb-0 lg:w-1/3">
              <div className="mb-12">
                <div className="flex items-center gap-2 mb-6">
                  <div className="h-0.5 w-6 bg-black"></div>
                  <span className="text-lg">Enquire Now</span>
                </div>
                <h1 className="text-2xl md:text-2xl lg:text-5xl notoh font-bold mb-4 ">
                  Confused<br />
                  About Your Options?
                </h1>
                <h2 className="text-3xl md:text-4xl font-bold mb-4 notov">
                  Let us help you.
                </h2>
                <p className="text-gray-900 mb-6">
                  Our team at Application Uni is here to help you with your queries. We generally respond within 48 hours. Feel free to reach out to us at any time.
                </p>
                {/* <button className="px-6 py-2 border border-black text-black hover:bg-black hover:text-white transition-colors duration-200 rounded-md flex items-center">
                  Send Enquiry
                  <span className="ml-2">→</span>
                </button> */}
              </div>
            </div>

            <ContactForm className={"lg:w-[60%] lg:mr-0"} />
          </div>
        </div>
      </div>
    )
  }
  